import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_cart_1: FaireProductEntity = {
  token: "atc_nf_cart_1",
  type: "product",
  name: "Chunks x TMG Bun Topper in Pansy",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/files/TMGBunTopperPansy_silo1.jpg?v=1723478382",
  priceDollars: 14.0,
  msrpDollars: 28.0,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
